// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1U3WK","dragIcon":"SortableItem_dragIcon__RSmOv","disabled":"SortableItem_disabled__3s00P"};